import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import {
  Getuserlistdata,
  getUserDetailsdata,
} from "../../../Services/Admin/Addmin";
import { Link } from "react-router-dom";
import { Eye, RotateCcw } from "lucide-react";
import { getAdminName, getBalanceStatementsApi } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { Users } from "lucide-react";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const UserDetails = () => {
  const TokenData = getUserFromToken();

  const [data, setData] = useState([]);
  const [userName, setUserName] = useState([]);
  const [Userid, setUserId] = useState(null);
  const [userNameList, setUserNameList] = useState([]);
  const [userNamed, setUserNamed] = useState("");
  const [status, setStatus] = useState("");
  const [input, setInput] = useState("");
  const [activeMarket, setActiveMarket] = useState("USD");
  // const [selectedUserBalance, setSelectedUserBalance] = useState(null);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [selectedUserBalance, setSelectedUserBalance] = useState([]);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const handleExport = () => {
    if (!data || data.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data",
        text: "No data available to export.",
      });
      return;
    }

    const excelData = data.map((item, index) => {
      const rowData = {
        "S.No": index + 1,
        "UserName": item.UserName || "-",
        "Total Credit": Number(item.totalCredit || 0).toFixed(2),
        "Total Debit": Number(item.totalDebit || 0).toFixed(2),
        "Remaining Balance": Number(item.Balance || 0).toFixed(2),
        "Total Brokerage": Number(item.totalBrokerage || 0).toFixed(2),
        "Realized P&L": Number(item.realizedPL || 0).toFixed(2),
        "Unrealized P&L": Number(item.unrealizedPL || 0).toFixed(2),
      };

      if (activeMarket === "INR") {
        rowData["Total Deposit"] = Number(item.totalDeposit || 0).toFixed(2);
        rowData["Total Withdrawal"] = Number(item.totalWithdrawal || 0).toFixed(2);
      }

      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users Details");
    XLSX.writeFile(workbook, `Users_Details_${activeMarket}.xlsx`);
  };

  const handlerefresh = () => {
    setInput("");
    setStatus("");
    setUserNamed("");
    setUserId("");
    setActiveMarket("USD");
  };

  useEffect(() => {
    fetchAdminList();
  }, [rowsPerPage, page]);

  const fetchAdminList = async () => {
    try {
      const response = await getAdminName();
      if (response.status) {
        setUserName(response.data);
      }
    } catch (error) {
      console.error("Admin list fetch error:", error);
    }
  };

  useEffect(() => {
    fetchUserList(Userid);
  }, [rowsPerPage, page, Userid, userNamed, input, status, activeMarket]);



  const fetchUserList = async () => {
    try {
      let req = {
        adminid: Userid,
        userId: userNamed || "",
        status: Number(status),
        input: Number(input) || "",
        page: page,
        limit: rowsPerPage
      };

      let response;

      if (activeMarket === "INR") {
        req.adminId = Userid;
        response = await getUserDetailsdata(req);
      } else {
        response = await Getuserlistdata(req);
      }

      if (response?.status) {
        setUserNameList(response.allUsers || []);

        const totalPagesFromAPI =
          response?.pagination?.totalPages ||
          response?.totalPages ||
          1;

        setTotalPages(totalPagesFromAPI);

        setData(response.data);
      } else {
        setData([]);
      }

    } catch (error) {
      console.error("User list fetch error:", error);
    }
  };




  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },
    { Header: "UserName", accessor: "UserName" },

    {
      Header: "Total Credit",
      accessor: "totalCredit",
      Cell: ({ row }) => {
        const value = Number(row.totalCredit);
        return isNaN(value) ? "0.00" : value.toFixed(2);
      },
    },

    {
      Header: "Total Debit",
      accessor: "totalDebit",
      Cell: ({ row }) => {
        const value = Number(row.totalDebit);
        return isNaN(value) ? "0.00" : value.toFixed(2);
      },
    },

    {
      Header: "Remaining Balance",
      accessor: "Balance",
      Cell: ({ row }) => {
        const value = Number(row.Balance);
        return isNaN(value) ? "0.00" : value.toFixed(2);
      },
    },

    { Header: "Total Brokerage", accessor: "totalBrokerage" },

    {
      Header: "Realized P&L",
      accessor: "realizedPL",
      Cell: ({ row }) => {
        const value = Number(row.realizedPL);
        return (
          <span style={{ color: value < 0 ? "red" : "green" }}>
            {isNaN(value) ? "0.00" : value.toFixed(2)}
          </span>
        );
      },
    },

    {
      Header: "Unrealized P&L",
      accessor: "unrealizedPL",
      Cell: ({ row }) => {
        const value = Number(row.unrealizedPL);
        return (
          <span style={{ color: value < 0 ? "red" : "green" }}>
            {isNaN(value) ? "0.00" : value.toFixed(2)}
          </span>
        );
      },
    },

    {
      Header: "Trade History",
      accessor: "tradeHistory",
      Cell: ({ row }) => (
        <Link to={`/superadmin/user-Trade-history/${row._id}`}>
          <Eye style={{ cursor: "pointer", color: "#1f2923ff" }} />
        </Link>
      ),
    },

    {
      Header: "Transition History",
      accessor: "view",
      Cell: ({ row }) => {
        const userId = row._id;

        return (
          <button
            className="btn btn-sm btn-primary"
            onClick={async () => {
              const res = await getBalanceStatementsApi({ userId });
              setSelectedUserBalance(res.status ? res.data : []);
              setShowBalanceModal(true);
            }}
          >
            View
          </button>
        );
      },
    },
  ];


  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };

  return (
    <div className="container-fluid mt-5" >
      <div className="row">
        <div className="col-lg-12">
          <div className="card transaction-table" style={{ background: "#f7f7f7" }}>
            <div className="card-header border-0  flex-wrap  d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0 fw-semibold gap-2"> <Users size={20} /> All Users</h4>
              <div className="wallet-tabs">
                <div className="btn-group" role="group" style={{ gap: "2px" }}>
                  {TokenData?.market.includes(0) && (
                    <button
                      type="button"
                      className={`btn ${activeMarket === "USD"
                        ? "btn-primary"
                        : "btn-outline-primary"
                        }`}
                      onClick={() => setActiveMarket("USD")}
                    >
                      <i className="fas fa-dollar-sign me-2"></i>
                      USD Wallet
                    </button>
                  )}

                  {TokenData?.market.includes(1) && (
                    <button
                      type="button"
                      className={`btn ${activeMarket === "INR"
                        ? "btn-primary"
                        : "btn-outline-primary"
                        }`}
                      onClick={() => setActiveMarket("INR")}
                    >
                      <i className="fas fa-rupee-sign me-2"></i>
                      INR Wallet
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="tab-content" id="myTabContent1">
                <div
                  className="tab-pane fade show active"
                  id="Week"
                  role="tabpanel"
                  aria-labelledby="Week-tab"
                >
                  <div className="row gx-3 gy-2 p-3 ms-3 mt-3">
                    <div className="col-md-2">
                      <label className="fw-bold mb-1">🛡️ Admin</label>
                      <select
                        className="form-select"
                        onChange={(e) => {
                          setUserId(e.target.value);
                          setUserNamed("");
                          setPage(1);
                        }}
                        value={Userid || ""}
                      >
                        <option value="">Select an admin</option>
                        {userName.map((admin) => (
                          <option key={admin._id} value={admin._id}>
                            {admin.UserName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <label className="fw-bold mb-1">🔍 Select User</label>
                      <select
                        className="form-select"
                        onChange={(e) => {
                          setUserNamed(e.target.value);
                          setPage(1);
                        }}
                        value={userNamed}
                      >
                        <option value="">Select a user</option>
                        {userNameList?.map((user, index) => (
                          <option key={index} value={user._id}>
                            {user.UserName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="fw-bold mb-1">🛡️ Select</label>
                      <select
                        className="form-select"
                        onChange={(e) => {
                          setStatus(e.target.value);
                          setPage(1);
                        }}

                        value={status}
                      >
                        <option value="">Select</option>
                        <option value="0">Less Than</option>
                        <option value="1">Greater Than</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="fw-bold mb-1">Enter Value</label>
                      <input
                        type="number"
                        className="form-control"
                        style={{ height: "33px", backgroundColor: "white" }}
                        placeholder="Enter number"
                        value={input}
                        onChange={(e) => {
                          setInput(e.target.value);
                          setPage(1);
                        }}

                      />
                    </div>
                    <div className="col-md-4 d-flex gap-2 mt-4">
                      <button
                        className="btn btn-dark d-flex align-items-center gap-2"
                        onClick={handlerefresh}
                        style={{ height: "33px" }}
                      >
                        <RotateCcw size={18} />
                        <span>Refresh</span>
                      </button>
                      <button
                        className="btn btn-success d-flex align-items-center gap-2"
                        onClick={handleExport}
                        style={{ height: "33px" }}
                      >
                        <i className="fas fa-file-excel" />
                        <span>Export</span>
                      </button>
                    </div>

                  </div>

                  <div className="px-3">
                    <Table
                      columns={columns}
                      data={data}
                      page={page}
                      totalPages={totalPages}
                      initialRowsPerPage={rowsPerPage}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsPerPageChange}


                    />
                    {/* 
                    <div
                      className="d-flex align-items-center"
                      style={{
                        marginBottom: "20px",
                        marginLeft: "20px",
                        marginTop: "-48px",
                      }}
                    >
                      Rows per page:
                      <select
                        className="form-select ml-2"
                        value={rowsPerPage}
                        onChange={(e) => setRowsPerPage(Number(e.target.value))}
                        style={{ width: "auto", marginLeft: "10px" }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div> */}
                  </div>
                  {/* Balance Statement Modal */}
                  {/* {showBalanceModal && (
                    <div
                      className="modal fade show "
                      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                    >
                      <div className="modal-dialog modal-lg">
                        <div className="modal-content">

                          <div className="modal-header">
                            <h5 className="modal-title">User Balance Statement</h5>
                            <button className="btn-close" onClick={() => setShowBalanceModal(false)}></button>
                          </div>

                          <div className="modal-body">
                            <div className="table-responsive">
                              <table className="table table-bordered">
                                <thead className="table-dark">
                                  <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th>Balance</th>
                                    <th>message</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedUserBalance?.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item?.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}</td>
                                      <td>{item?.type || "-"}</td>
                                      <td>{item?.Amount || 0}</td>
                                      <td>{item?.Balance || 0}</td>
                                      <td>{item?.message || "-"}</td>
                                    </tr>
                                  ))}
                                </tbody>

                              </table>
                            </div>
                          </div>

                          <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowBalanceModal(false)}>
                              Close
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  )} */}
                  {showBalanceModal && (
                    <>
                      {/* Backdrop */}
                      <div
                        className="modal-backdrop fade show"
                        style={{
                          background: "rgba(0,0,0,0.45)",
                          backdropFilter: "blur(3px)",
                        }}
                      ></div>

                      {/* Modal */}
                      <div
                        className="modal fade show d-flex justify-content-center align-items-center"
                        style={{
                          position: "fixed",
                          inset: 0,
                          zIndex: 1050,
                          background: "rgba(0,0,0,0.0)"
                        }}
                      >
                        <div className="modal-dialog modal-lg">
                          <div className="modal-content shadow-lg rounded-3">

                            <div className="modal-header">
                              <h5 className="modal-title">User Balance Statement</h5>
                              <button className="btn-close" onClick={() => setShowBalanceModal(false)}></button>
                            </div>

                            <div className="modal-body">
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead className="table-dark">
                                    <tr>
                                      <th>Date</th>
                                      <th>Type</th>
                                      <th>Amount</th>
                                      <th>Balance</th>
                                      <th>Message</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {selectedUserBalance?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item?.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}</td>
                                        <td>{item?.type || "-"}</td>
                                        <td>{item?.Amount || 0}</td>
                                        <td>{item?.Balance || 0}</td>
                                        <td>{item?.message || "-"}</td>
                                      </tr>
                                    ))}
                                  </tbody>

                                </table>
                              </div>
                            </div>

                            <div className="modal-footer">
                              <button className="btn btn-secondary" onClick={() => setShowBalanceModal(false)}>
                                Close
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>
                    </>
                  )}





                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
